// @ts-nocheck
import {ConfEnv} from "../../../config/config";
import privateRequest from "../../../Infra/http/private.request";

export const addFavoriteGameService = async (gameInfo: {game_id: string | number; game_provider: string}) => {
  return privateRequest.post(ConfEnv.API_GAMES.ADD_FAVORITE_GAME, gameInfo);
};

export const listMyFavoriteGamesService = async () => {
  return privateRequest.get(ConfEnv.API_GAMES.LIST_FAVORITE_GAME);
};

export const deleteFavoriteGameService = async (id: string | number) => {
  return privateRequest.delete(`${ConfEnv.API_GAMES.DELETE_FAVORITE_GAME}/${encodeURIComponent(id)}`);
};
